<ew-mat-dialog-custom>
  <ew-mat-stepper-custom [progressBar]="false" [textForSendButton]="'deleteProvider:buttonText' | translate"
    [classForSendButton]="'warn'" [validations]="[true]" [sendIn]="'penultimate'" (send)="deleteProvider()">
    <ew-mat-stepper-custom-step>
      <div class="text-center grid gap-4 max-w-2xl m-auto">
        <div class="mb-5 text-5xl font-bold">
          {{
          ('deleteProvider:title' | translate).replace(
          ':providerName',
          this.dialogData.alias
          )
          }}
        </div>
        <div>{{ 'deleteProvider:subtitle' | translate }}</div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <mat-progress-spinner class="m-auto my-5" [diameter]="24" [mode]="'indeterminate'" *ngIf="loading">
      </mat-progress-spinner>

      <div class="text-center grid gap-4 max-w-2xl" *ngIf="!loading && !success">
        <img class="w-10 m-auto" width="150" src="assets/circle-error.svg" alt="" />
        <div class="mb-5 text-5xl font-bold">
          {{ 'deleteProvider:errorTitle' | translate }}
        </div>
        <div>{{ 'deleteProvider:errorSubtitle' | translate }}</div>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>